import {createI18n} from 'vue-i18n';
import checkoutEn from './locales/checkout/en.json';
import checkoutNl from './locales/checkout/nl.json';
import checkoutFr from './locales/checkout/fr.json';
import checkoutDe from './locales/checkout/de.json';
import gateEn from './locales/gate/en.json';
import gateNl from './locales/gate/nl.json';
import gateFr from './locales/gate/fr.json';
import gateDe from './locales/gate/de.json';

export type Locale = 'en' | 'nl' | 'fr' | 'de';

export const locales: Locale[] = ['en', 'nl', 'fr', 'de'];

// How each language names itself, for language pickers
export const localeLabels: Record<Locale, string> = {
    en: 'English',
    nl: 'Nederlands',
    fr: 'Français',
    de: 'Deutsch',
};

function isLocale(value: string): value is Locale {
    return (locales as string[]).includes(value);
}

// Languages come either as plain locales ("nl") or as the site codes the
// shop uses ("nlnl", "befr", …), several of which share a translation;
// anything unknown falls back to English
export function localeFromLang(lang: string): Locale {
    const value = lang.toLowerCase();

    if (isLocale(value))
        return value;

    switch (value) {
        case 'benl':
        case 'nlnl':
            return 'nl';
        case 'befr':
        case 'frfr':
            return 'fr';
        case 'dede':
            return 'de';
        default:
            return 'en';
    }
}

// The first browser language we have a translation for, English otherwise
export function localeFromBrowser(): Locale {
    if (typeof navigator === 'undefined')
        return 'en';

    for (const language of navigator.languages ?? [navigator.language]) {
        const code = language.slice(0, 2).toLowerCase();

        if (isLocale(code))
            return code;
    }

    return 'en';
}

// Every page owns its translations (locales/<page>/<locale>.json) and
// loads them with useI18n({useScope: 'local', messages}), so keys never
// need a page prefix
export const checkoutMessages = {en: checkoutEn, nl: checkoutNl, fr: checkoutFr, de: checkoutDe};
export const gateMessages = {en: gateEn, nl: gateNl, fr: gateFr, de: gateDe};

export const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
});
